import clsx from 'clsx';
import Button from 'components/Common/Button/Button';
import { useMergedStyles } from 'hooks/useMergedStyles';
import { FC } from 'react';
import { Styles } from 'types/styles';

import styles from './PlaceholderBanner.module.scss';

type Props = {
  newStyles?: Styles;
  Icon: FC;
  headingText?: string;
  text?: string;
  handleClick?: () => void;
  buttonText?: string;
  additionalClass?: string;
};

const PlaceholderBanner: FC<Props> = ({
  newStyles = {},
  Icon,
  headingText,
  text,
  handleClick,
  buttonText,
  additionalClass = '',
}) => {
  const mergedStyles = useMergedStyles(styles, newStyles);

  return (
    <div
      className={clsx(mergedStyles['placeholder-banner-wrapper'], {
        [additionalClass]: additionalClass,
      })}
    >
      <div className={mergedStyles['placeholder-banner']}>
        <div className={mergedStyles['placeholder-banner-icon-wrapper']}>
          <Icon />
        </div>
        <div className={mergedStyles['placeholder-banner-content']}>
          {headingText && <h2>{headingText}</h2>}
          {text && <p>{text}</p>}
          {handleClick && (
            <div className={mergedStyles['placeholder-banner-button']}>
              <Button handleClick={handleClick}>{buttonText}</Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlaceholderBanner;
